<template>
    <div class="w-full flex el-login">
        <el-col :span="12">
            <div class="el-center-right-content">
                <v-app class="main-app">
                    <div class="el-login-card">
                        <div slot="header" class="clearfix">
                            <h1 class="el-title-with-icon">
                                {{ $t('text.resetPassword') }}
                            </h1>
                        </div>
                        <el-form ref="form" :model="formData" :rules="rules">
                            <el-form-item prop="password" class="mb-10">
                                <v-select
                                    :items="languages"
                                    @input="changeLanguage"
                                    :label="$t('form.label.language')"
                                    dark
                                ></v-select>
                                <v-text-field
                                    name="password"
                                    :label="$t('form.label.password')"
                                    v-model="formData.password"
                                    @keyup.enter.native="submit"
                                    min="8"
                                    :append-icon="
                                        passwordShow
                                            ? 'visibility'
                                            : 'visibility_off'
                                    "
                                    :append-icon-cb="
                                        () => (passwordShow = !passwordShow)
                                    "
                                    :type="passwordShow ? 'text' : 'password'"
                                    hide-details
                                ></v-text-field>
                            </el-form-item>
                            <el-form-item prop="confirmPassword" class="mb-10">
                                <v-text-field
                                    name="confirmPassword"
                                    :label="$t('form.label.confirmPassword')"
                                    v-model="formData.confirmPassword"
                                    @keyup.enter.native="submit"
                                    min="8"
                                    :append-icon="
                                        confirmPasswordShow
                                            ? 'visibility'
                                            : 'visibility_off'
                                    "
                                    :append-icon-cb="
                                        () => (confirmPasswordShow = !confirmPasswordShow)
                                    "
                                    :type="confirmPasswordShow ? 'text' : 'password'"
                                    hide-details
                                ></v-text-field>
                            </el-form-item>
                            <el-form-item>
                                <v-btn
                                    round
                                    color="primary"
                                    @click="submit"
                                    loader="loading"
                                    :disabled="loading"
                                    dark
                                >
                                    {{ $t('form.button.submit') }}
                                </v-btn>
                                <router-link
                                    :to="{ name: 'login' }"
                                    class="link"
                                >
                                    {{ $t('form.button.cancel') }}
                                </router-link>
                            </el-form-item>
                        </el-form>
                    </div>
                </v-app>
            </div>
        </el-col>
        <el-col :span="12" class="el-login-bg">
            <div class="el-center-content flex">
                <img src="/images/logo/stc_logo-with-tag.svg" alt="STC" />
            </div>
        </el-col>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'reset-password',

    data() {
        return {
            passwordShow: false,
            confirmPasswordShow: false,
            loading: false,
            formData: {
                password: '',
                confirmPassword: '',
            },
        }
    },

    computed: {
        languages() {
            return [
                { text: this.$t('data.label.english'), value: 'en-US' },
                { text: this.$t('data.label.swedish'), value: 'sv-SE' },
            ]
        },

        rules() {
            const rules = {
                password: [
                    {
                        validator: this.validatePassword,
                        trigger: 'blur',
                    },
                ],
                confirmPassword: [
                    {
                        validator: this.validateConfirmPassword,
                        trigger: 'blur',
                    },
                ],
            }

            Vue.nextTick(() => this.$refs.form.clearValidate())

            return rules
        },
    },

    methods: {
        ...mapActions(['changeLanguage']),

        validatePassword(rule, value, cb) {
            if (value === '') {
                cb(
                    new Error(
                        this.$t('form.validation.required', {
                            name: this.$t('form.label.password'),
                        })
                    )
                )
            } else {
                if (this.formData.confirmPassword !== '') {
                    this.$refs.form.validateField('confirmPassword')
                }
                cb()
            }
        },

        validateConfirmPassword(rule, value, cb) {
            if (value === '') {
                cb(
                    new Error(
                        this.$t('form.validation.required', {
                            name: this.$t('form.label.confirmPassword'),
                        })
                    )
                )
            } else if (value !== this.formData.password) {
                cb(new Error(this.$t('form.validation.passwordMisMatch')))
            } else {
                cb()
            }
        },

        async submit() {
            this.loading = true

            try {
                await this.$refs.form.validate()

                await this.$http.post('User/ResetPassword', {
                    ResetRequestToken: this.$route.params.token,
                    Password: this.formData.password,
                })

                this.$message({
                    type: 'success',
                    message: this.$i18n.i18next.t('message.success.updated', {
                        section: this.$i18n.i18next.t('form.label.password'),
                    }),
                })
                this.$router.push({ name: 'login' })
            } catch (e) {
                if (e === false) {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: `${e}.`,
                    })
                }
            }

            this.loading = false
        },
    },
}
</script>
